import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
    locales: ['en', 'fr', 'es', 'pt'],
    defaultLocale: 'en',
    pathnames: {
        '/': '/',
        '/tv-rights-buyers': {
            fr: '/acheteurs-droits-tv',
            es: '/compradores-derechos-tv',
            pt: '/compradores-direitos-tv',
        },
        '/tv-rights-sellers': {
            fr: '/vendeurs-droits-tv',
            es: '/vendedores-derechos-tv',
            pt: '/vendedores-direitos-tv',
        },
        '/programs': {
            fr: '/programmes',
            es: '/programas',
            pt: '/programas',
        },
        '/programs/[id]': {
            fr: '/programmes/[id]',
            es: '/programas/[id]',
            pt: '/programas/[id]',
        },
        '/formats': {
            fr: '/formats',
            es: '/formats',
            pt: '/formats',
        },
        '/formats/[id]': {
            fr: '/formats/[id]',
            es: '/formats/[id]',
            pt: '/formats/[id]',
        },
        '/dashboard': {
            fr: '/tableau-de-bord',
            es: '/panel-de-control',
            pt: '/painel-de-controle',
        },
        '/your-programs': {
            fr: '/vos-programmes',
            es: '/tus-programas',
            pt: '/seus-programas',
        },
        '/your-formats': {
            fr: '/vos-formats',
            es: '/tus-formatos',
            pt: '/seus-formatos',
        },
        '/licenses': {
            fr: '/licences',
            es: '/licencias',
            pt: '/licencas',
        },
        '/transactions': {
            fr: '/transactions',
            es: '/actas',
            pt: '/transações',
        },
        '/settings': {
            fr: '/parametres',
            es: '/ajustes',
            pt: '/configuracoes',
        },
        '/cart': {
            fr: '/panier',
            es: '/carrito',
            pt: '/carrinho',
        },
        '/cart/confirmation-page/[id]': {
            fr: '/panier/page-de-confirmation/[id]',
            es: '/carrito/pagina-de-confirmacion/[id]',
            pt: '/carrinho/pagina-de-confirmacao/[id]',
        },
    },
});
